
// import { api } from './APIMiddlewares'
// import { setupAxios } from '../app/modules/auth'

import { api } from './APIMiddlewares'
import { setupAxios } from '../app/modules/auth'

// GET SHIFT MANAGEMENT USERS

export const getShiftManagementUsers = (
  page = 1,
  limit = 100,
  search = ''
) => {
  const { token, tenantId } = setupAxios()

  return api.get(
    `/shift-management/users?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
    token,
    tenantId,
    false
  )
}


// BULK UPDATE WORKING SHIFT (FIXED)

export const bulkUpdateWorkingShift = (
  userIds: string[],
  shiftId: string
) => {
  const { token, tenantId } = setupAxios()

  return api.post(
    '/shift-management/bulk-update-shift',
    token,
    tenantId,
    {
      body: JSON.stringify({ userIds, shiftId }) //  REQUIRED
    },
    true
  )
}
/* =========================================
   EXPORT SHIFT USERS
========================================= */

export const exportShiftUsers = () => {
  const { token, tenantId } = setupAxios()

  return api.get(
    `/shift-management/export`,
    token,
    tenantId,
    false
  )
}
